






































import { Vue, Component, Model, Prop } from 'vue-property-decorator';

import BaseDatepicker from './BaseDatepicker.vue';

import { formatDateForInput  } from '@/utils/date';
import { ISOMonth, ISOCalendarDate } from '@/utils/date/types';

@Component({
    components: {
        BaseDatepicker,
    }
})
export default class DatepickerPopup extends Vue {
    @Model('update:date', { required: true }) readonly date!: ISOCalendarDate
    @Prop({ default: 'ГГГГ-ММ-ДД' }) readonly placeholder!: string
    @Prop() readonly min!: string
    @Prop() readonly max!: string
    @Prop({ default: 'right' }) readonly alignment!: 'left' | 'right'
    @Prop({ default: '' }) readonly activatorClass!: string
    @Prop({ }) readonly initialMonth!: ISOMonth
    @Prop({ default: false }) readonly highlight!: ISOCalendarDate
    @Prop({ required: false }) readonly title!: string;
    
    menu = false

    get dateModel() {
        return this.date
    }

    set dateModel(date) {
        this.$emit('update:date', date)
    }

    get formattedDate() {
        return formatDateForInput(this.date);
    }

    get left() {
        return this.alignment === 'left';
    }

    get right() {
        return this.alignment === 'right';
    }
}
